export default __webpack_public_path__ + "static/media/FAQ_8_1.ce9c984d.png";